import React, { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import FormikFormErrorHandler from './FormikFormErrorHandler';
import { useField } from 'formik';
import Tooltip from '@mui/material/Tooltip';

interface IProps {
    children: React.ReactNode;
    className: string;
    "data-testid"?: string;
    intl: any;//IntlConfig;
    name: string;
    onBlur: () => void;
    onChange: () => void;
    placeholder: string;
    value: string;
    disabled: boolean;
    readOnly: boolean;
    maxLength: number;
    shouldnotshowerror: boolean;
    isnegativeallowed: boolean;
    isnegativeanddotallowed: boolean;
    min: number;
    max: number;
    defaultvaluecondition: boolean;
    initialvalue: number;
    show_error_on_tooltip?: boolean;
}

const FormikFormNumberInput = (props: IProps) => {
    const [field, meta, helpers] = useField(props);
    const errorClass = `${(meta.error && meta.touched) ? 'error' : ''}`;
    const _placeholder = props.placeholder
        ? props.intl.formatMessage({ id: props.placeholder })
        : props.placeholder;

    const { defaultvaluecondition, initialvalue, show_error_on_tooltip } = props;

    useEffect(() => {
        if (defaultvaluecondition && initialvalue !== field.value) {
            helpers.setValue(initialvalue);
        }
    }, [defaultvaluecondition, helpers, initialvalue, field.value]);

    const _error = meta.error
        ? props.intl.formatMessage({ id: meta.error })
        : meta.error;
    return (
        <>
            <Tooltip placement="left" title={show_error_on_tooltip && meta.touched && meta.error && _error} arrow>
                <input
                    {...field} {...props}
                    placeholder={_placeholder}
                    className={props.className + ' ' + errorClass}
                    disabled={props.disabled}
                    type='number'
                    readOnly={props.readOnly}
                    value={field.value === -999 ? '' : field.value}
                    onKeyDown={e => {
                        if (props.isnegativeallowed) {
                            (e.key === "E" || e.key === "+" || e.key === "e" || e.key === ".") && e.preventDefault()
                        }
                        else if (props.isnegativeanddotallowed) { (e.key === "E" || e.key === "+" || e.key === "e" || (e.key === "-" && (field.value !== -999))) && e.preventDefault() }
                        else
                            (e.key === "E" || e.key === "+" || e.key === "e" || e.key === "." || e.key === "-") && e.preventDefault()
                    }}
                    onChange={event => {
                        if (event.target.value.length > props.maxLength)
                            event.target.value = event.target.value.slice(0, props.maxLength);
                        helpers.setValue(isNaN(parseFloat(event.target.value)) ? -999 : parseFloat(event.target.value));
                    }}
                />
            </Tooltip>
            {!(props.shouldnotshowerror || show_error_on_tooltip) && <FormikFormErrorHandler intl={props.intl} meta={meta} />}
        </>
    );
};

export default injectIntl(FormikFormNumberInput);